import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import Head from "next/head";
import BigBrainScript from "/components/core/head/bigbrain-script";
const isProduction = process.env.NODE_ENV === "production";
const PAGE_TYPE = "external_sync";
const BbVisitorSyncComponent = ({ source })=>{
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: /*#__PURE__*/ _jsx(Head, {
            children: /*#__PURE__*/ _jsx(BigBrainScript, {
                isProduction: isProduction,
                pageType: PAGE_TYPE,
                preventPageView: true,
                crossDomain: true,
                emitVisitorId: true,
                emitTargetOrigin: source
            })
        })
    });
};
export default BbVisitorSyncComponent;
